// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kurulum-page {
    padding: 16px;
    min-height: 100vh;
    background-color: #f5f5f5;
}

.kurulum-header-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.kurulum-header {
    text-align: center;
    padding: 16px 0;
}

.kurulum-filters-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.filter-item {
    margin-bottom: 8px;
}

.filter-item .ant-typography {
    display: block;
    margin-bottom: 4px;
    font-size: 14px;
    color: #666;
}

.filter-actions {
    display: flex;
    align-items: flex-end;
    height: 100%;
    padding-top: 20px;
}

.kurulum-content-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* table-layout bir DIV'de gecersizdir (.ant-table bir div); width:100%!important
   ise ic <table>'in yatay kaydirma icin ihtiyac duydugu genislemeyi kisitlar.
   Sarmalayici zaten blok eleman, min-width yeterli. */
.kurulum-content-card .ant-table {
    min-width: 100%;
}

.kurulum-content-card .ant-table-container {
    width: 100% !important;
}

.kurulum-content-card .ant-table-tbody > tr > td {
    padding: 2px 4px !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
    overflow: visible !important;
    font-size: 10px !important;
    line-height: 1.2 !important;
    height: auto !important;
    text-overflow: clip !important;
}

.kurulum-content-card .ant-table-tbody > tr > td > div,
.kurulum-content-card .ant-table-tbody > tr > td > span {
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
    overflow: visible !important;
    max-width: 100% !important;
    text-overflow: clip !important;
    display: block !important;
}

.kurulum-content-card .ant-table-tbody > tr {
    height: auto !important;
}

.kurulum-content-card .ant-table-tbody > tr > td * {
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
}

.dark-theme .kurulum-content-card .ant-table-tbody > tr > td > div,
.dark-theme .kurulum-content-card .ant-table-tbody > tr > td > span {
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
    overflow: visible !important;
    max-width: 100% !important;
    text-overflow: clip !important;
    display: block !important;
}

.dark-theme .kurulum-content-card .ant-table-tbody > tr {
    height: auto !important;
}

.dark-theme .kurulum-content-card .ant-table-tbody > tr > td * {
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
}

.kurulum-content-card .ant-table-tbody > tr > td .ant-btn {
    font-size: 10px !important;
    height: 20px !important;
    padding: 2px 6px !important;
    line-height: 1.2 !important;
}

.kurulum-content-card .ant-table-tbody > tr > td .ant-btn .anticon {
    font-size: 10px !important;
}

.kurulum-content-card .ant-table-thead > tr > th .ant-btn {
    font-size: 10px !important;
    height: 16px !important;
    padding: 0 2px !important;
    line-height: 1.2 !important;
}

.kurulum-content-card .ant-table-thead > tr > th .ant-btn .anticon {
    font-size: 10px !important;
}

.dark-theme .kurulum-content-card .ant-table-tbody > tr > td .ant-btn {
    font-size: 10px !important;
    height: 20px !important;
    padding: 2px 6px !important;
    line-height: 1.2 !important;
}

.dark-theme .kurulum-content-card .ant-table-tbody > tr > td .ant-btn .anticon {
    font-size: 10px !important;
}

.dark-theme .kurulum-content-card .ant-table-thead > tr > th .ant-btn {
    font-size: 10px !important;
    height: 16px !important;
    padding: 0 2px !important;
    line-height: 1.2 !important;
}

.dark-theme .kurulum-content-card .ant-table-thead > tr > th .ant-btn .anticon {
    font-size: 10px !important;
}

.kurulum-content-card .ant-table-thead > tr > th .ant-table-column-sorter {
    display: none !important;
}

.kurulum-content-card .ant-table-thead > tr > th .ant-table-column-sorter .anticon {
    display: none !important;
}

.kurulum-content-card .ant-table-thead > tr > th {
    padding: 4px 6px !important;
    font-weight: 400 !important;
    background-color: #fafafa;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    font-size: 10px !important;
    line-height: 1.2 !important;
}

.kurulum-content-card .ant-table-tbody > tr:hover > td {
    background-color: #f5f5f5;
}

.kurulum-content-card .ant-tabs-tab {
    font-weight: 500;
    padding: 12px 16px;
}

.kurulum-content-card .ant-tabs-tab-active {
    color: #1890ff;
}

.kurulum-content-card .ant-tabs-ink-bar {
    background: #1890ff;
}

.kurulum-actions {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 16px;
}

.kurulum-content-card .ant-table {
    border-radius: 6px;
}

.kurulum-content-card .ant-table-thead > tr > th {
    background: #fafafa;
    font-weight: 600;
    color: #262626;
    border-bottom: 2px solid #f0f0f0;
    padding: 4px 6px !important;
    font-size: 10px !important;
    line-height: 1.2 !important;
}

.kurulum-content-card .ant-table-tbody > tr:hover > td {
    background: #f5f5f5;
}

.kurulum-content-card .ant-table-tbody > tr > td {
    border-bottom: 1px solid #f0f0f0;
    padding: 2px 4px !important;
    font-size: 10px !important;
    line-height: 1.2 !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
}

.kurulum-content-card .ant-pagination {
    margin-top: 16px;
    text-align: right;
}

@media (max-width: 1200px) {
    .kurulum-page {
        padding: 12px;
    }
}

@media (max-width: 768px) {
    .kurulum-page {
        padding: 8px;
    }
    
    .filter-actions {
        padding-top: 8px;
    }
    
    .kurulum-actions {
        flex-wrap: wrap;
        gap: 8px;
    }
    
    .kurulum-content-card .ant-tabs-tab {
        padding: 8px 12px;
        font-size: 14px;
    }
}

@media (max-width: 480px) {
    .kurulum-page {
        padding: 4px;
    }
    
    .kurulum-header {
        padding: 8px 0;
    }
    
    .filter-actions {
        padding-top: 4px;
    }
    
    .kurulum-actions {
        flex-direction: column;
        align-items: stretch;
    }
    
    .kurulum-actions .ant-btn {
        margin-bottom: 4px;
    }
}

.dark-theme .kurulum-page {
    background-color: var(--dark-bg);
}

.dark-theme .kurulum-header-card,
.dark-theme .kurulum-filters-card,
.dark-theme .kurulum-content-card {
    background-color: var(--dark-bg-secondary) !important;
    border-color: var(--dark-border) !important;
}

.dark-theme .kurulum-content-card .ant-table-thead > tr > th {
    background-color: var(--dark-bg-header) !important;
    color: var(--dark-text) !important;
    border-bottom-color: var(--dark-border) !important;
    padding: 4px 6px !important;
    font-size: 10px !important;
    line-height: 1.2 !important;
    font-weight: 600 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
}

.dark-theme .kurulum-content-card .ant-table-tbody > tr:hover > td {
    background-color: var(--dark-bg-header) !important;
    padding: 2px 4px !important;
    font-size: 10px !important;
    line-height: 1.2 !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
    overflow: visible !important;
    height: auto !important;
    text-overflow: clip !important;
}

.dark-theme .kurulum-content-card .ant-table-tbody > tr > td {
    background-color: var(--dark-bg-secondary) !important;
    color: var(--dark-text) !important;
    border-bottom-color: var(--dark-border) !important;
    padding: 2px 4px !important;
    font-size: 10px !important;
    line-height: 1.2 !important;
    white-space: normal !important;
    word-wrap: break-word !important;
    word-break: break-word !important;
    overflow: visible !important;
    height: auto !important;
    text-overflow: clip !important;
}

.dark-theme .filter-item .ant-typography {
    color: var(--dark-text) !important;
}

.dark-theme .dark-button {
    background-color: var(--dark-bg-header) !important;
    border-color: var(--dark-border) !important;
    color: var(--dark-text) !important;
}

.dark-theme .dark-button:hover {
    background-color: var(--dark-bg) !important;
    border-color: var(--color-primary) !important;
    color: var(--color-primary) !important;
}

.dark-theme .dark-input {
    background-color: var(--dark-bg) !important;
    border-color: var(--dark-border) !important;
    color: var(--dark-text) !important;
}

.dark-theme .dark-input:hover {
    border-color: var(--color-primary) !important;
}

.dark-theme .dark-input:focus {
    border-color: var(--color-primary) !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
}

.dark-theme .dark-select .ant-select-selector {
    background-color: var(--dark-bg) !important;
    border-color: var(--dark-border) !important;
    color: var(--dark-text) !important;
}

.dark-theme .dark-select .ant-select-selection-item {
    color: var(--dark-text) !important;
}

.dark-theme .dark-select .ant-select-selection-placeholder {
    color: var(--dark-text-muted) !important;
}

.dark-theme .dark-date-picker .ant-picker-input > input {
    background-color: var(--dark-bg) !important;
    color: var(--dark-text) !important;
}

.dark-theme .dark-date-picker .ant-picker-suffix {
    color: var(--dark-text-muted) !important;
}

.dark-theme .dark-card {
    background-color: var(--dark-bg-secondary) !important;
    border-color: var(--dark-border) !important;
}

.dark-theme .dark-card .ant-card-head {
    background-color: var(--dark-bg-header) !important;
    border-bottom-color: var(--dark-border) !important;
    color: var(--dark-text) !important;
}

.dark-theme .dark-card .ant-card-body {
    background-color: var(--dark-bg-secondary) !important;
    color: var(--dark-text) !important;
}

.kurulum-content-card .ant-spin-container {
    min-height: 200px;
}

.kurulum-content-card .ant-alert {
    border-radius: 6px;
}

.kurulum-content-card .ant-empty {
    padding: 40px 0;
}

.kurulum-content-card .ant-table-body::-webkit-scrollbar {
    height: 8px;
}

.kurulum-content-card .ant-table-body::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.kurulum-content-card .ant-table-body::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

.kurulum-content-card .ant-table-body::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.expired-row {
    border: 2px solid #ff4d4f !important;
    background-color: #fff2f0 !important;
}

.expired-row td {
    background-color: #fff2f0 !important;
    color: #ff4d4f !important;
    font-weight: bold !important;
    border-color: #ff4d4f !important;
}

.ant-table-tbody .expired-row td {
    background-color: #fff2f0 !important;
    color: #ff4d4f !important;
    font-weight: bold !important;
    border-color: #ff4d4f !important;
}

.ant-table-tbody .expired-row td span {
    color: #ff4d4f !important;
    font-weight: bold !important;
}

.ant-table-tbody .expired-row td div {
    color: #ff4d4f !important;
    font-weight: bold !important;
}

.expired-row:hover td {
    background-color: #ffebe6 !important;
}

.dark-theme .expired-row {
    border: 2px solid #ff4d4f !important;
    background-color: #2a1215 !important;
}

.dark-theme .expired-row td {
    background-color: #2a1215 !important;
    color: #ff4d4f !important;
    font-weight: bold !important;
    border-color: #ff4d4f !important;
}

.dark-theme .ant-table-tbody .expired-row td {
    background-color: #2a1215 !important;
    color: #ff4d4f !important;
    font-weight: bold !important;
    border-color: #ff4d4f !important;
}

.dark-theme .ant-table-tbody .expired-row td span {
    color: #ff4d4f !important;
    font-weight: bold !important;
}

.dark-theme .ant-table-tbody .expired-row td div {
    color: #ff4d4f !important;
    font-weight: bold !important;
}

.ant-table-tbody .approaching-row {
    border: 2px solid #faad14 !important;
    background-color: #fffbe6 !important;
}

.ant-table-tbody .approaching-row td {
    background-color: #fffbe6 !important;
    color: #d48806 !important;
    font-weight: bold !important;
    border-color: #faad14 !important;
}

.ant-table-tbody .approaching-row:hover td {
    background-color: #fff7e6 !important;
    color: #d48806 !important;
}

.ant-table-tbody .approaching-row td span {
    color: #d48806 !important;
    font-weight: bold !important;
}

.ant-table-tbody .approaching-row td div {
    color: #d48806 !important;
    font-weight: bold !important;
}

.dark-theme .ant-table-tbody .approaching-row {
    border: 2px solid #faad14 !important;
    background-color: #2a1f00 !important;
}

.dark-theme .ant-table-tbody .approaching-row td {
    background-color: #2a1f00 !important;
    color: #faad14 !important;
    font-weight: bold !important;
    border-color: #faad14 !important;
}

.dark-theme .ant-table-tbody .approaching-row:hover td {
    background-color: #3a2f00 !important;
    color: #faad14 !important;
}

.dark-theme .ant-table-tbody .approaching-row td span {
    color: #faad14 !important;
    font-weight: bold !important;
}

.dark-theme .ant-table-tbody .approaching-row td div {
    color: #faad14 !important;
    font-weight: bold !important;
}

.dark-theme .expired-row:hover td {
    background-color: #3a1a1d !important;
}

.kurulum-hareketleri-page {
    padding: 20px;
    min-height: 100vh;
    background-color: #f5f5f5;
}

.kurulum-hareketleri-page .ant-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.kurulum-hareketleri-page .ant-table {
    border-radius: 6px;
}

.kurulum-hareketleri-page .ant-table-thead > tr > th {
    background: #fafafa;
    font-weight: 600;
    color: #262626;
    border-bottom: 2px solid #f0f0f0;
    padding: 12px;
}

.kurulum-hareketleri-page .ant-table-tbody > tr > td {
    border-bottom: 1px solid #f0f0f0;
    padding: 8px 12px;
}

.kurulum-hareketleri-page .ant-table-tbody > tr:hover > td {
    background: #f5f5f5;
}

.kurulum-hareketleri-page .ant-form-item-label > label {
    font-weight: 500;
    color: #262626;
}

.kurulum-hareketleri-page .ant-input,
.kurulum-hareketleri-page .ant-select-selector,
.kurulum-hareketleri-page .ant-picker {
    border-radius: 6px;
}

.kurulum-hareketleri-page .ant-btn {
    border-radius: 6px;
    font-weight: 500;
}

.kurulum-hareketleri-page .ant-btn-primary {
    background: #1890ff;
    border-color: #1890ff;
}

.kurulum-hareketleri-page .ant-btn-primary:hover {
    background: #40a9ff;
    border-color: #40a9ff;
}

.dark-theme .kurulum-hareketleri-page {
    background-color: var(--dark-bg);
}

.dark-theme .kurulum-hareketleri-page .ant-card {
    background-color: var(--dark-bg-secondary) !important;
    border-color: var(--dark-border) !important;
}

.dark-theme .kurulum-hareketleri-page .ant-card-head {
    background-color: var(--dark-bg-header) !important;
    border-bottom-color: var(--dark-border) !important;
    color: var(--dark-text) !important;
}

.dark-theme .kurulum-hareketleri-page .ant-card-body {
    background-color: var(--dark-bg-secondary) !important;
    color: var(--dark-text) !important;
}

.dark-theme .kurulum-hareketleri-page .ant-table-thead > tr > th {
    background-color: var(--dark-bg-header) !important;
    color: var(--dark-text) !important;
    border-bottom-color: var(--dark-border) !important;
    padding: 12px !important;
    font-weight: 600 !important;
}

.dark-theme .kurulum-hareketleri-page .ant-table-tbody > tr > td {
    background-color: var(--dark-bg-secondary) !important;
    color: var(--dark-text) !important;
    border-bottom-color: var(--dark-border) !important;
    padding: 8px 12px !important;
}

.dark-theme .kurulum-hareketleri-page .ant-table-tbody > tr:hover > td {
    background-color: var(--dark-bg-header) !important;
    padding: 8px 12px !important;
}

.dark-theme .kurulum-hareketleri-page .ant-form-item-label > label {
    color: var(--dark-text) !important;
}

.dark-theme .kurulum-hareketleri-page .dark-input {
    background-color: var(--dark-bg) !important;
    border-color: var(--dark-border) !important;
    color: var(--dark-text) !important;
}

.dark-theme .kurulum-hareketleri-page .dark-input:hover {
    border-color: var(--color-primary) !important;
}

.dark-theme .kurulum-hareketleri-page .dark-input:focus {
    border-color: var(--color-primary) !important;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
}

.dark-theme .kurulum-hareketleri-page .dark-select .ant-select-selector {
    background-color: var(--dark-bg) !important;
    border-color: var(--dark-border) !important;
    color: var(--dark-text) !important;
}

.dark-theme .kurulum-hareketleri-page .dark-select .ant-select-selection-item {
    color: var(--dark-text) !important;
}

.dark-theme .kurulum-hareketleri-page .dark-select .ant-select-selection-placeholder {
    color: var(--dark-text-muted) !important;
}

.dark-theme .kurulum-hareketleri-page .dark-date-picker .ant-picker-input > input {
    background-color: var(--dark-bg) !important;
    color: var(--dark-text) !important;
}

.dark-theme .kurulum-hareketleri-page .dark-date-picker .ant-picker-suffix {
    color: var(--dark-text-muted) !important;
}

.dark-theme .kurulum-hareketleri-page .dark-button {
    background-color: var(--dark-bg-header) !important;
    border-color: var(--dark-border) !important;
    color: var(--dark-text) !important;
}

.dark-theme .kurulum-hareketleri-page .dark-button:hover {
    background-color: var(--dark-bg) !important;
    border-color: var(--color-primary) !important;
    color: var(--color-primary) !important;
}

.dark-theme .kurulum-hareketleri-page .dark-form .ant-form-item-label > label {
    color: var(--dark-text) !important;
}

@media (max-width: 1200px) {
    .kurulum-hareketleri-page {
        padding: 16px;
    }
}

@media (max-width: 768px) {
    .kurulum-hareketleri-page {
        padding: 12px;
    }
    
    .kurulum-hareketleri-page .ant-card {
        margin-bottom: 16px;
    }
}

@media (max-width: 480px) {
    .kurulum-hareketleri-page {
        padding: 8px;
    }
    
    .kurulum-hareketleri-page .ant-card {
        margin-bottom: 12px;
    }
    
    .kurulum-hareketleri-page .ant-table-thead > tr > th,
    .kurulum-hareketleri-page .ant-table-tbody > tr > td {
        padding: 6px 8px;
        font-size: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/insaat/KurulumHareketleriPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;;sDAEsD;AACtD;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;IACjC,4BAA4B;IAC5B,0BAA0B;IAC1B,2BAA2B;IAC3B,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;;IAEI,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;IACjC,4BAA4B;IAC5B,0BAA0B;IAC1B,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;;IAEI,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;IACjC,4BAA4B;IAC5B,0BAA0B;IAC1B,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,yBAAyB;IACzB,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;IAClC,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;;IAGI,qDAAqD;IACrD,2CAA2C;AAC/C;;AAEA;IACI,kDAAkD;IAClD,kCAAkC;IAClC,kDAAkD;IAClD,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;AACtC;;AAEA;IACI,kDAAkD;IAClD,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;IACjC,4BAA4B;IAC5B,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,qDAAqD;IACrD,kCAAkC;IAClC,kDAAkD;IAClD,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;IACjC,4BAA4B;IAC5B,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kDAAkD;IAClD,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,2CAA2C;IAC3C,6CAA6C;IAC7C,sCAAsC;AAC1C;;AAEA;IACI,2CAA2C;IAC3C,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;IAC7C,wDAAwD;AAC5D;;AAEA;IACI,2CAA2C;IAC3C,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,qDAAqD;IACrD,2CAA2C;AAC/C;;AAEA;IACI,kDAAkD;IAClD,kDAAkD;IAClD,kCAAkC;AACtC;;AAEA;IACI,qDAAqD;IACrD,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;;IAGI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qDAAqD;IACrD,2CAA2C;AAC/C;;AAEA;IACI,kDAAkD;IAClD,kDAAkD;IAClD,kCAAkC;AACtC;;AAEA;IACI,qDAAqD;IACrD,kCAAkC;AACtC;;AAEA;IACI,kDAAkD;IAClD,kCAAkC;IAClC,kDAAkD;IAClD,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,qDAAqD;IACrD,kCAAkC;IAClC,kDAAkD;IAClD,4BAA4B;AAChC;;AAEA;IACI,kDAAkD;IAClD,4BAA4B;AAChC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,2CAA2C;IAC3C,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;IAC7C,wDAAwD;AAC5D;;AAEA;IACI,2CAA2C;IAC3C,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kDAAkD;IAClD,2CAA2C;IAC3C,kCAAkC;AACtC;;AAEA;IACI,2CAA2C;IAC3C,6CAA6C;IAC7C,sCAAsC;AAC1C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;QAEI,gBAAgB;QAChB,eAAe;IACnB;AACJ","sourcesContent":[".kurulum-page {\n    padding: 16px;\n    min-height: 100vh;\n    background-color: #f5f5f5;\n}\n\n.kurulum-header-card {\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.kurulum-header {\n    text-align: center;\n    padding: 16px 0;\n}\n\n.kurulum-filters-card {\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.filter-item {\n    margin-bottom: 8px;\n}\n\n.filter-item .ant-typography {\n    display: block;\n    margin-bottom: 4px;\n    font-size: 14px;\n    color: #666;\n}\n\n.filter-actions {\n    display: flex;\n    align-items: flex-end;\n    height: 100%;\n    padding-top: 20px;\n}\n\n.kurulum-content-card {\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* table-layout bir DIV'de gecersizdir (.ant-table bir div); width:100%!important\n   ise ic <table>'in yatay kaydirma icin ihtiyac duydugu genislemeyi kisitlar.\n   Sarmalayici zaten blok eleman, min-width yeterli. */\n.kurulum-content-card .ant-table {\n    min-width: 100%;\n}\n\n.kurulum-content-card .ant-table-container {\n    width: 100% !important;\n}\n\n.kurulum-content-card .ant-table-tbody > tr > td {\n    padding: 2px 4px !important;\n    white-space: normal !important;\n    word-wrap: break-word !important;\n    word-break: break-word !important;\n    overflow: visible !important;\n    font-size: 10px !important;\n    line-height: 1.2 !important;\n    height: auto !important;\n    text-overflow: clip !important;\n}\n\n.kurulum-content-card .ant-table-tbody > tr > td > div,\n.kurulum-content-card .ant-table-tbody > tr > td > span {\n    white-space: normal !important;\n    word-wrap: break-word !important;\n    word-break: break-word !important;\n    overflow: visible !important;\n    max-width: 100% !important;\n    text-overflow: clip !important;\n    display: block !important;\n}\n\n.kurulum-content-card .ant-table-tbody > tr {\n    height: auto !important;\n}\n\n.kurulum-content-card .ant-table-tbody > tr > td * {\n    white-space: normal !important;\n    word-wrap: break-word !important;\n    word-break: break-word !important;\n}\n\n.dark-theme .kurulum-content-card .ant-table-tbody > tr > td > div,\n.dark-theme .kurulum-content-card .ant-table-tbody > tr > td > span {\n    white-space: normal !important;\n    word-wrap: break-word !important;\n    word-break: break-word !important;\n    overflow: visible !important;\n    max-width: 100% !important;\n    text-overflow: clip !important;\n    display: block !important;\n}\n\n.dark-theme .kurulum-content-card .ant-table-tbody > tr {\n    height: auto !important;\n}\n\n.dark-theme .kurulum-content-card .ant-table-tbody > tr > td * {\n    white-space: normal !important;\n    word-wrap: break-word !important;\n    word-break: break-word !important;\n}\n\n.kurulum-content-card .ant-table-tbody > tr > td .ant-btn {\n    font-size: 10px !important;\n    height: 20px !important;\n    padding: 2px 6px !important;\n    line-height: 1.2 !important;\n}\n\n.kurulum-content-card .ant-table-tbody > tr > td .ant-btn .anticon {\n    font-size: 10px !important;\n}\n\n.kurulum-content-card .ant-table-thead > tr > th .ant-btn {\n    font-size: 10px !important;\n    height: 16px !important;\n    padding: 0 2px !important;\n    line-height: 1.2 !important;\n}\n\n.kurulum-content-card .ant-table-thead > tr > th .ant-btn .anticon {\n    font-size: 10px !important;\n}\n\n.dark-theme .kurulum-content-card .ant-table-tbody > tr > td .ant-btn {\n    font-size: 10px !important;\n    height: 20px !important;\n    padding: 2px 6px !important;\n    line-height: 1.2 !important;\n}\n\n.dark-theme .kurulum-content-card .ant-table-tbody > tr > td .ant-btn .anticon {\n    font-size: 10px !important;\n}\n\n.dark-theme .kurulum-content-card .ant-table-thead > tr > th .ant-btn {\n    font-size: 10px !important;\n    height: 16px !important;\n    padding: 0 2px !important;\n    line-height: 1.2 !important;\n}\n\n.dark-theme .kurulum-content-card .ant-table-thead > tr > th .ant-btn .anticon {\n    font-size: 10px !important;\n}\n\n.kurulum-content-card .ant-table-thead > tr > th .ant-table-column-sorter {\n    display: none !important;\n}\n\n.kurulum-content-card .ant-table-thead > tr > th .ant-table-column-sorter .anticon {\n    display: none !important;\n}\n\n.kurulum-content-card .ant-table-thead > tr > th {\n    padding: 4px 6px !important;\n    font-weight: 400 !important;\n    background-color: #fafafa;\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n    font-size: 10px !important;\n    line-height: 1.2 !important;\n}\n\n.kurulum-content-card .ant-table-tbody > tr:hover > td {\n    background-color: #f5f5f5;\n}\n\n.kurulum-content-card .ant-tabs-tab {\n    font-weight: 500;\n    padding: 12px 16px;\n}\n\n.kurulum-content-card .ant-tabs-tab-active {\n    color: #1890ff;\n}\n\n.kurulum-content-card .ant-tabs-ink-bar {\n    background: #1890ff;\n}\n\n.kurulum-actions {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 12px 0;\n    border-bottom: 1px solid #f0f0f0;\n    margin-bottom: 16px;\n}\n\n.kurulum-content-card .ant-table {\n    border-radius: 6px;\n}\n\n.kurulum-content-card .ant-table-thead > tr > th {\n    background: #fafafa;\n    font-weight: 600;\n    color: #262626;\n    border-bottom: 2px solid #f0f0f0;\n    padding: 4px 6px !important;\n    font-size: 10px !important;\n    line-height: 1.2 !important;\n}\n\n.kurulum-content-card .ant-table-tbody > tr:hover > td {\n    background: #f5f5f5;\n}\n\n.kurulum-content-card .ant-table-tbody > tr > td {\n    border-bottom: 1px solid #f0f0f0;\n    padding: 2px 4px !important;\n    font-size: 10px !important;\n    line-height: 1.2 !important;\n    white-space: normal !important;\n    word-wrap: break-word !important;\n    word-break: break-word !important;\n}\n\n.kurulum-content-card .ant-pagination {\n    margin-top: 16px;\n    text-align: right;\n}\n\n@media (max-width: 1200px) {\n    .kurulum-page {\n        padding: 12px;\n    }\n}\n\n@media (max-width: 768px) {\n    .kurulum-page {\n        padding: 8px;\n    }\n    \n    .filter-actions {\n        padding-top: 8px;\n    }\n    \n    .kurulum-actions {\n        flex-wrap: wrap;\n        gap: 8px;\n    }\n    \n    .kurulum-content-card .ant-tabs-tab {\n        padding: 8px 12px;\n        font-size: 14px;\n    }\n}\n\n@media (max-width: 480px) {\n    .kurulum-page {\n        padding: 4px;\n    }\n    \n    .kurulum-header {\n        padding: 8px 0;\n    }\n    \n    .filter-actions {\n        padding-top: 4px;\n    }\n    \n    .kurulum-actions {\n        flex-direction: column;\n        align-items: stretch;\n    }\n    \n    .kurulum-actions .ant-btn {\n        margin-bottom: 4px;\n    }\n}\n\n.dark-theme .kurulum-page {\n    background-color: var(--dark-bg);\n}\n\n.dark-theme .kurulum-header-card,\n.dark-theme .kurulum-filters-card,\n.dark-theme .kurulum-content-card {\n    background-color: var(--dark-bg-secondary) !important;\n    border-color: var(--dark-border) !important;\n}\n\n.dark-theme .kurulum-content-card .ant-table-thead > tr > th {\n    background-color: var(--dark-bg-header) !important;\n    color: var(--dark-text) !important;\n    border-bottom-color: var(--dark-border) !important;\n    padding: 4px 6px !important;\n    font-size: 10px !important;\n    line-height: 1.2 !important;\n    font-weight: 600 !important;\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n}\n\n.dark-theme .kurulum-content-card .ant-table-tbody > tr:hover > td {\n    background-color: var(--dark-bg-header) !important;\n    padding: 2px 4px !important;\n    font-size: 10px !important;\n    line-height: 1.2 !important;\n    white-space: normal !important;\n    word-wrap: break-word !important;\n    word-break: break-word !important;\n    overflow: visible !important;\n    height: auto !important;\n    text-overflow: clip !important;\n}\n\n.dark-theme .kurulum-content-card .ant-table-tbody > tr > td {\n    background-color: var(--dark-bg-secondary) !important;\n    color: var(--dark-text) !important;\n    border-bottom-color: var(--dark-border) !important;\n    padding: 2px 4px !important;\n    font-size: 10px !important;\n    line-height: 1.2 !important;\n    white-space: normal !important;\n    word-wrap: break-word !important;\n    word-break: break-word !important;\n    overflow: visible !important;\n    height: auto !important;\n    text-overflow: clip !important;\n}\n\n.dark-theme .filter-item .ant-typography {\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .dark-button {\n    background-color: var(--dark-bg-header) !important;\n    border-color: var(--dark-border) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .dark-button:hover {\n    background-color: var(--dark-bg) !important;\n    border-color: var(--color-primary) !important;\n    color: var(--color-primary) !important;\n}\n\n.dark-theme .dark-input {\n    background-color: var(--dark-bg) !important;\n    border-color: var(--dark-border) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .dark-input:hover {\n    border-color: var(--color-primary) !important;\n}\n\n.dark-theme .dark-input:focus {\n    border-color: var(--color-primary) !important;\n    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;\n}\n\n.dark-theme .dark-select .ant-select-selector {\n    background-color: var(--dark-bg) !important;\n    border-color: var(--dark-border) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .dark-select .ant-select-selection-item {\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .dark-select .ant-select-selection-placeholder {\n    color: var(--dark-text-muted) !important;\n}\n\n.dark-theme .dark-date-picker .ant-picker-input > input {\n    background-color: var(--dark-bg) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .dark-date-picker .ant-picker-suffix {\n    color: var(--dark-text-muted) !important;\n}\n\n.dark-theme .dark-card {\n    background-color: var(--dark-bg-secondary) !important;\n    border-color: var(--dark-border) !important;\n}\n\n.dark-theme .dark-card .ant-card-head {\n    background-color: var(--dark-bg-header) !important;\n    border-bottom-color: var(--dark-border) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .dark-card .ant-card-body {\n    background-color: var(--dark-bg-secondary) !important;\n    color: var(--dark-text) !important;\n}\n\n.kurulum-content-card .ant-spin-container {\n    min-height: 200px;\n}\n\n.kurulum-content-card .ant-alert {\n    border-radius: 6px;\n}\n\n.kurulum-content-card .ant-empty {\n    padding: 40px 0;\n}\n\n.kurulum-content-card .ant-table-body::-webkit-scrollbar {\n    height: 8px;\n}\n\n.kurulum-content-card .ant-table-body::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n}\n\n.kurulum-content-card .ant-table-body::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 4px;\n}\n\n.kurulum-content-card .ant-table-body::-webkit-scrollbar-thumb:hover {\n    background: #a8a8a8;\n}\n\n.expired-row {\n    border: 2px solid #ff4d4f !important;\n    background-color: #fff2f0 !important;\n}\n\n.expired-row td {\n    background-color: #fff2f0 !important;\n    color: #ff4d4f !important;\n    font-weight: bold !important;\n    border-color: #ff4d4f !important;\n}\n\n.ant-table-tbody .expired-row td {\n    background-color: #fff2f0 !important;\n    color: #ff4d4f !important;\n    font-weight: bold !important;\n    border-color: #ff4d4f !important;\n}\n\n.ant-table-tbody .expired-row td span {\n    color: #ff4d4f !important;\n    font-weight: bold !important;\n}\n\n.ant-table-tbody .expired-row td div {\n    color: #ff4d4f !important;\n    font-weight: bold !important;\n}\n\n.expired-row:hover td {\n    background-color: #ffebe6 !important;\n}\n\n.dark-theme .expired-row {\n    border: 2px solid #ff4d4f !important;\n    background-color: #2a1215 !important;\n}\n\n.dark-theme .expired-row td {\n    background-color: #2a1215 !important;\n    color: #ff4d4f !important;\n    font-weight: bold !important;\n    border-color: #ff4d4f !important;\n}\n\n.dark-theme .ant-table-tbody .expired-row td {\n    background-color: #2a1215 !important;\n    color: #ff4d4f !important;\n    font-weight: bold !important;\n    border-color: #ff4d4f !important;\n}\n\n.dark-theme .ant-table-tbody .expired-row td span {\n    color: #ff4d4f !important;\n    font-weight: bold !important;\n}\n\n.dark-theme .ant-table-tbody .expired-row td div {\n    color: #ff4d4f !important;\n    font-weight: bold !important;\n}\n\n.ant-table-tbody .approaching-row {\n    border: 2px solid #faad14 !important;\n    background-color: #fffbe6 !important;\n}\n\n.ant-table-tbody .approaching-row td {\n    background-color: #fffbe6 !important;\n    color: #d48806 !important;\n    font-weight: bold !important;\n    border-color: #faad14 !important;\n}\n\n.ant-table-tbody .approaching-row:hover td {\n    background-color: #fff7e6 !important;\n    color: #d48806 !important;\n}\n\n.ant-table-tbody .approaching-row td span {\n    color: #d48806 !important;\n    font-weight: bold !important;\n}\n\n.ant-table-tbody .approaching-row td div {\n    color: #d48806 !important;\n    font-weight: bold !important;\n}\n\n.dark-theme .ant-table-tbody .approaching-row {\n    border: 2px solid #faad14 !important;\n    background-color: #2a1f00 !important;\n}\n\n.dark-theme .ant-table-tbody .approaching-row td {\n    background-color: #2a1f00 !important;\n    color: #faad14 !important;\n    font-weight: bold !important;\n    border-color: #faad14 !important;\n}\n\n.dark-theme .ant-table-tbody .approaching-row:hover td {\n    background-color: #3a2f00 !important;\n    color: #faad14 !important;\n}\n\n.dark-theme .ant-table-tbody .approaching-row td span {\n    color: #faad14 !important;\n    font-weight: bold !important;\n}\n\n.dark-theme .ant-table-tbody .approaching-row td div {\n    color: #faad14 !important;\n    font-weight: bold !important;\n}\n\n.dark-theme .expired-row:hover td {\n    background-color: #3a1a1d !important;\n}\n\n.kurulum-hareketleri-page {\n    padding: 20px;\n    min-height: 100vh;\n    background-color: #f5f5f5;\n}\n\n.kurulum-hareketleri-page .ant-card {\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.kurulum-hareketleri-page .ant-table {\n    border-radius: 6px;\n}\n\n.kurulum-hareketleri-page .ant-table-thead > tr > th {\n    background: #fafafa;\n    font-weight: 600;\n    color: #262626;\n    border-bottom: 2px solid #f0f0f0;\n    padding: 12px;\n}\n\n.kurulum-hareketleri-page .ant-table-tbody > tr > td {\n    border-bottom: 1px solid #f0f0f0;\n    padding: 8px 12px;\n}\n\n.kurulum-hareketleri-page .ant-table-tbody > tr:hover > td {\n    background: #f5f5f5;\n}\n\n.kurulum-hareketleri-page .ant-form-item-label > label {\n    font-weight: 500;\n    color: #262626;\n}\n\n.kurulum-hareketleri-page .ant-input,\n.kurulum-hareketleri-page .ant-select-selector,\n.kurulum-hareketleri-page .ant-picker {\n    border-radius: 6px;\n}\n\n.kurulum-hareketleri-page .ant-btn {\n    border-radius: 6px;\n    font-weight: 500;\n}\n\n.kurulum-hareketleri-page .ant-btn-primary {\n    background: #1890ff;\n    border-color: #1890ff;\n}\n\n.kurulum-hareketleri-page .ant-btn-primary:hover {\n    background: #40a9ff;\n    border-color: #40a9ff;\n}\n\n.dark-theme .kurulum-hareketleri-page {\n    background-color: var(--dark-bg);\n}\n\n.dark-theme .kurulum-hareketleri-page .ant-card {\n    background-color: var(--dark-bg-secondary) !important;\n    border-color: var(--dark-border) !important;\n}\n\n.dark-theme .kurulum-hareketleri-page .ant-card-head {\n    background-color: var(--dark-bg-header) !important;\n    border-bottom-color: var(--dark-border) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .kurulum-hareketleri-page .ant-card-body {\n    background-color: var(--dark-bg-secondary) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .kurulum-hareketleri-page .ant-table-thead > tr > th {\n    background-color: var(--dark-bg-header) !important;\n    color: var(--dark-text) !important;\n    border-bottom-color: var(--dark-border) !important;\n    padding: 12px !important;\n    font-weight: 600 !important;\n}\n\n.dark-theme .kurulum-hareketleri-page .ant-table-tbody > tr > td {\n    background-color: var(--dark-bg-secondary) !important;\n    color: var(--dark-text) !important;\n    border-bottom-color: var(--dark-border) !important;\n    padding: 8px 12px !important;\n}\n\n.dark-theme .kurulum-hareketleri-page .ant-table-tbody > tr:hover > td {\n    background-color: var(--dark-bg-header) !important;\n    padding: 8px 12px !important;\n}\n\n.dark-theme .kurulum-hareketleri-page .ant-form-item-label > label {\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .kurulum-hareketleri-page .dark-input {\n    background-color: var(--dark-bg) !important;\n    border-color: var(--dark-border) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .kurulum-hareketleri-page .dark-input:hover {\n    border-color: var(--color-primary) !important;\n}\n\n.dark-theme .kurulum-hareketleri-page .dark-input:focus {\n    border-color: var(--color-primary) !important;\n    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;\n}\n\n.dark-theme .kurulum-hareketleri-page .dark-select .ant-select-selector {\n    background-color: var(--dark-bg) !important;\n    border-color: var(--dark-border) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .kurulum-hareketleri-page .dark-select .ant-select-selection-item {\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .kurulum-hareketleri-page .dark-select .ant-select-selection-placeholder {\n    color: var(--dark-text-muted) !important;\n}\n\n.dark-theme .kurulum-hareketleri-page .dark-date-picker .ant-picker-input > input {\n    background-color: var(--dark-bg) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .kurulum-hareketleri-page .dark-date-picker .ant-picker-suffix {\n    color: var(--dark-text-muted) !important;\n}\n\n.dark-theme .kurulum-hareketleri-page .dark-button {\n    background-color: var(--dark-bg-header) !important;\n    border-color: var(--dark-border) !important;\n    color: var(--dark-text) !important;\n}\n\n.dark-theme .kurulum-hareketleri-page .dark-button:hover {\n    background-color: var(--dark-bg) !important;\n    border-color: var(--color-primary) !important;\n    color: var(--color-primary) !important;\n}\n\n.dark-theme .kurulum-hareketleri-page .dark-form .ant-form-item-label > label {\n    color: var(--dark-text) !important;\n}\n\n@media (max-width: 1200px) {\n    .kurulum-hareketleri-page {\n        padding: 16px;\n    }\n}\n\n@media (max-width: 768px) {\n    .kurulum-hareketleri-page {\n        padding: 12px;\n    }\n    \n    .kurulum-hareketleri-page .ant-card {\n        margin-bottom: 16px;\n    }\n}\n\n@media (max-width: 480px) {\n    .kurulum-hareketleri-page {\n        padding: 8px;\n    }\n    \n    .kurulum-hareketleri-page .ant-card {\n        margin-bottom: 12px;\n    }\n    \n    .kurulum-hareketleri-page .ant-table-thead > tr > th,\n    .kurulum-hareketleri-page .ant-table-tbody > tr > td {\n        padding: 6px 8px;\n        font-size: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
